import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CommandCentre from './pages/CommandCentre';
import Checkout from './pages/Checkout';
import FinanceOverview from './pages/FinanceOverview';
import Transactions from './pages/Transactions';
import PastTransactions from './pages/PastTransactions';
import Accounts from './pages/Accounts';
import Invoices from './pages/Invoices';
import Catalog from './pages/Catalog';
import Forms from './pages/Forms';
import LandingPages from './pages/LandingPages';
import MediaLibrary from './pages/MediaLibrary';
import Contacts from './pages/Contacts';
import Conversations from './pages/Conversations';
import Integrations from './pages/Integrations';
import Workflows from './pages/Workflows';
import Templates from './pages/Templates';
import Inventory from './pages/Inventory';
import Capacity from './pages/Capacity';
import Settings from './pages/Settings';
import Storefront from './pages/Storefront';
import FormAnalytics from './pages/FormAnalytics';
import Assistant from './pages/Assistant';

function App() {
  const { user, loading } = useAuth();
  const isAuthDomain = typeof window !== 'undefined' && window.location.hostname === 'a.techassembly.io';

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--surface-primary)' }}>
        Loading...
      </div>
    );
  }

  if (isAuthDomain) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <LandingPage />} />
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route element={user ? <Layout /> : <Navigate to="/login" replace />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/command-centre" element={<CommandCentre />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/storefront" element={<Storefront />} />
        <Route path="/finance" element={<FinanceOverview />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/record-transaction" element={<PastTransactions />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/forms" element={<Forms />} />
        <Route path="/pages" element={<LandingPages />} />
        <Route path="/media-library" element={<MediaLibrary />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/conversations" element={<Conversations />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/workflows" element={<Workflows />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/capacity" element={<Capacity />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/form-analytics" element={<FormAnalytics />} />
        <Route path="*" element={<div style={{ padding: 40 }}>Page not found</div>} />
      </Route>
    </Routes>
  );
}

export default App;
